export const RECEIVE_ARTISTS = 'RECEIVE_ARTISTS'
export const RECEIVE_ARTIST = 'RECEIVE_ARTIST'
export const RECEIVE_ARTISTS_ERROR = 'RECEIVE_ARTISTS_ERROR'
export const RECEIVE_ARTIST_ERROR = 'RECEIVE_ARTISTS_ERROR'
export const CLEAR_ARTISTS = 'CLEAR_ARTISTS'
export const DELETE_RELATED_ARTIST_CONTENT = 'DELETE_RELATED_ARTIST_CONTENT'
export const RECEIVE_RELATED_ARTIST_CONTENT = 'RECEIVE_RELATED_ARTIST_CONTENT'
